import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';

import * as RegisterCreditCardActions from './register-credit-card.actions';
import { FantazUIError } from '@fantaz/shared/data-access/models';

export const REGISTER_CREDIT_CARD_FEATURE_KEY = 'registerCreditCard';

export interface RegisterCreditCardState {
  verifying: boolean;
  verified: boolean;
  error?: FantazUIError | null; // last known error (if any)
}

export interface RegisterCreditCardPartialState {
  readonly [REGISTER_CREDIT_CARD_FEATURE_KEY]: RegisterCreditCardState;
}

export const initialRegisterCreditCardState: RegisterCreditCardState = {
  // set initial required properties
  verifying: false,
  verified: false,
  error: null,
};

const reducer = createReducer(
  initialRegisterCreditCardState,
  on(RegisterCreditCardActions.verifyUserWithCreditCard, (state) => ({
    ...state,
    verifying: true,
    verified: false,
    error: null,
  })),
  on(RegisterCreditCardActions.verifyUserWithCreditCardSuccess, (state) => ({
    ...state,
    verifying: false,
    verified: true,
    error: null,
  })),
  on(
    RegisterCreditCardActions.verifyUserWithCreditCardFailure,
    (state, { error }) => ({
      ...state,
      verifying: false,
      verified: false,
      error,
    }),
  ),
  on(RegisterCreditCardActions.openRegisterCreditCardDialog, (state) => ({
    ...state,
    verifying: false,
    verified: false,
    error: null,
  })),
);

export function registerCreditCardReducer(
  state: RegisterCreditCardState | undefined,
  action: Action,
) {
  return reducer(state, action);
}
